import { render } from "./AddVendorNoteModal.vue?vue&type=template&id=00c04246"
import script from "./AddVendorNoteModal.vue?vue&type=script&lang=js"
export * from "./AddVendorNoteModal.vue?vue&type=script&lang=js"

import "@/modules/customer/styles/AddCustomerNoteModal.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__